import React, { useEffect, useRef, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { cn } from "../../lib/utils";

const Modal = ({
  children,
  header = true,
  onClose = () => {},
  isOpen = false,
  title,
  size = "xl",
}) => {
  const headerRef = useRef(null);
  const [height, setHeight] = useState(0);

  const modalSize = {
    xs: "sm:max-w-xs",
    sm: "sm:max-w-sm",
    md: "sm:max-w-md",
    lg: "sm:max-w-lg",
    xl: "sm:max-w-xl",
    xl2: "sm:max-w-2xl",
    xl3: "sm:max-w-3xl",
    xl4: "sm:max-w-4xl",
    xl5: "sm:max-w-5xl",
    xl6: "sm:max-w-6xl",
    xl7: "sm:max-w-7xl",
    xl8: "sm:max-w-8xl",
    xl9: "sm:max-w-9xl",
    full: "max-w-full",
  };

  useEffect(() => {
    if (headerRef?.current) {
      setHeight(headerRef?.current?.offsetHeight);
    }
  }, [headerRef.current]);

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) onClose(false);
      }}
    >
      <DialogContent className={cn("max-h-screen", modalSize[size])}>
        {header && (
          <DialogHeader ref={headerRef}>
            <DialogTitle>{title}</DialogTitle>
          </DialogHeader>
        )}
        <div
          className={cn("w-full overflow-auto")}
          style={{ maxHeight: `calc(100vh - ${height + 65}px)` }}
        >
          {children}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
